const getLoginUserName = (authData) => {
        const group = authData ? authData.signInUserSession.idToken.payload['cognito:groups'][0] : 'Demo';
        //console.log(authData)
        //console.log(group)
        return group
}
export default getLoginUserName;
